import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {ComissionamentoService} from '../../services/comissionamento.service';

@Component({
  selector: 'app-modal-comissionamento-pedido',
  templateUrl: './modal-comissionamento-pedido.component.html',
  styleUrls: ['./modal-comissionamento-pedido.component.scss']
})
export class ModalComissionamentoPedidoComponent implements OnInit, OnChanges {
  @Input() pedido: any;
  @Input() labelOperacional: string;
  @Output() fechou = new EventEmitter<void>();
  @Output() itemSalvo = new EventEmitter<any>();

  itensComissionamento: any[] = [];
  comissionados: any[] = [];
  carregando = false;
  salvando = false;
  erro = '';
  justificativa = '';

  constructor(private comissionamentoService: ComissionamentoService) {}

  ngOnInit() {
    this.carregue();
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes.pedido && !changes.pedido.firstChange)
      this.carregue();
  }

  feche() {
    this.fechou.emit();
  }

  labelOperacionalSingular() {
    const label = String(this.labelOperacional || this.pedido?.empresa?.comissionadoLabel || 'Comissionado').trim();
    if(label.toLowerCase().endsWith('s'))
      return label.substring(0, label.length - 1);

    return label;
  }

  deveExibirJustificativa() {
    return this.itensComissionamento.some((item: any) => this.itemTeveTrocaComissionado(item));
  }

  salveComissionadoItem(item: any) {
    if(!item?.comissionadoId || this.salvando)
      return;

    this.erro = '';
    this.salvando = true;
    const houveTroca = this.itemTeveTrocaComissionado(item);
    this.comissionamentoService.atribuaComissionadoItem(
      this.pedido.guid,
      item.itemPedidoId,
      item.comissionadoId,
      houveTroca ? this.justificativa : null
    ).then((itemAtualizado: any) => {
      Object.assign(item, itemAtualizado || {});
      item.comissionadoId = item.comissionadoId ? Number(item.comissionadoId) : null;
      item.comissionadoOriginalId = item.comissionadoId || null;
      if(!this.deveExibirJustificativa())
        this.justificativa = '';
      this.itemSalvo.emit(item);
    }).catch((erro) => {
      this.erro = erro?.message || erro || 'Não foi possível salvar o comissionado.';
    }).finally(() => {
      this.salvando = false;
    });
  }

  private carregue() {
    if(!this.pedido?.guid)
      return;

    this.itensComissionamento = [];
    this.justificativa = '';
    this.erro = '';
    this.carregando = true;

    Promise.all([
      this.comissionamentoService.listeItensPedido(this.pedido.guid),
      this.comissionamentoService.listeComissionados()
    ]).then(([itens, comissionados]: any[]) => {
      this.comissionados = this.normalizeComissionados(comissionados || []);
      this.itensComissionamento = (itens || []).map((item: any) => {
        const comissionadoId = item.comissionadoId ? Number(item.comissionadoId) : null;
        return {
          ...item,
          comissionadoId,
          comissionadoOriginalId: comissionadoId
        };
      });
    }).catch((erro) => {
      this.erro = erro?.message || erro || 'Não foi possível carregar os itens com comissão.';
    }).finally(() => {
      this.carregando = false;
    });
  }

  private itemTeveTrocaComissionado(item: any) {
    return !!item?.comissionadoOriginalId &&
      !!item?.comissionadoId &&
      Number(item.comissionadoOriginalId) !== Number(item.comissionadoId);
  }

  private normalizeComissionados(comissionados: any[]) {
    return (comissionados || []).map((comissionado: any) => ({
      ...comissionado,
      id: Number(comissionado.id)
    }));
  }
}
